/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Enum representing the status of an integration connection.
 * @export
 */
export const ConnectionStatus = {
    Active: 'Active',
    NotVerified: 'NotVerified',
    Deleted: 'Deleted'
};
export function instanceOfConnectionStatus(value) {
    for (const key in ConnectionStatus) {
        if (Object.prototype.hasOwnProperty.call(ConnectionStatus, key)) {
            if (ConnectionStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function ConnectionStatusFromJSON(json) {
    return ConnectionStatusFromJSONTyped(json, false);
}
export function ConnectionStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ConnectionStatusToJSON(value) {
    return value;
}
export function ConnectionStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
